/**
 * @author       jordan.sookikian@zumper.com (Jordan Sookikian)
 * @copyright    Copyright (c) 2021, Zumper
 */

import { payloadReducer } from '@zcode/reducers'
import { trueReducer } from '@zcode/reducers'
import type { ProfileModule } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { type ExtractActions, type Values, handleAction, handleActions } from 'redux-actions'
import type * as actions from '../actions'
import { SET_FETCHED_PROFILE, SET_PROFILE } from '../constants/index'

type Actions = ExtractActions<Values<typeof actions>>

export const profileReducer = combineReducers<ProfileModule, Actions>({
  fetchedProfile: handleActions(
    { [SET_FETCHED_PROFILE]: trueReducer, [SET_PROFILE]: trueReducer },
    false
  ),
  profile: handleAction<ProfileModule['profile'], Actions, typeof SET_PROFILE>(
    SET_PROFILE,
    payloadReducer,
    {}
  ),
})
